import React from "react";
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  title,
  subtitle,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-304" data-mp="3f36q7i3iln6m">
      <h2 className={`font-display text-[2rem] font-bold uppercase leading-[1.08] sm:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-305" data-mp="3jzdnkmhuhqcy">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed ${dark ? "text-white/80" : "text-ink-soft"}`} data-id="element-306" data-mp="gi57o86oh0kv">{subtitle}</p>}
    </div>;
}